// import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import { createInsertAtCurrentPosition, createReplace } from './actions/create-actions';
import { createContinueInChatForAgent } from './actions/create-continue-in-chat';
import { CONFIG_ITEM_KEYS } from './config-item-keys';
export var createAgentConfigItem = function createAgentConfigItem(agent, editorPluginAIProvider) {
  var _editorPluginAIProvid, _editorPluginAIProvid2;
  var continueInChat = createContinueInChatForAgent({
    appearance: 'secondary',
    agent: agent,
    product: editorPluginAIProvider.product,
    actionSideEffect: (_editorPluginAIProvid = editorPluginAIProvider.actionSideEffects) === null || _editorPluginAIProvid === void 0 ? void 0 : _editorPluginAIProvid['continueInChat'],
    actionOverride: (_editorPluginAIProvid2 = editorPluginAIProvider.actionOverrides) === null || _editorPluginAIProvid2 === void 0 ? void 0 : _editorPluginAIProvid2['continueInChat']
  });
  return {
    key: CONFIG_ITEM_KEYS.ROVO_AGENT,
    title: aiConfigItemMessages.agentConfigTitle,
    description: aiConfigItemMessages.agentConfigDescription,
    statusLozengeType: 'beta',
    promptHint: aiConfigItemMessages.agentConfigPromptHint,
    // Required, since hasInitialPreset guard in palette state machine
    // checks this property for whether to transition to 'preset label'
    // (agent palette mode) during initialisation.
    promptLabel: {
      defaultMessage: agent === null || agent === void 0 ? void 0 : agent.name,
      // Ignored via go/ees005
      // eslint-disable-next-line require-unicode-regexp
      id: "fabric.editor.ai.config.item.range.agent.".concat((agent === null || agent === void 0 ? void 0 : agent.name.toLocaleLowerCase().replace(/\s+/g, '.')) || 'label')
    },
    disableInterrogation: function disableInterrogation() {
      return false;
    },
    agent: agent,
    intentSchemaId: 'DISABLED',
    getBackendModel: function getBackendModel() {
      return 'assistance-service';
    },
    actions: {
      empty: [continueInChat, createInsertAtCurrentPosition({
        appearance: 'primary',
        isRovoAgentAction: true
      })],
      selection: [continueInChat, createReplace({
        appearance: 'primary',
        isRovoAgentAction: true
      })]
    },
    secondaryActions: []
  };
};